import cx from 'classnames'
import {ReactNode} from 'react'

type Props = {
  children: ReactNode
  className?: string
  onClick?: () => void
}

export const Frame = ({children, className, onClick}: Props) => {
  return (
    <div className={cx('border border-solid rounded-lg border-gray-3', className)} onClick={onClick}>
      {children}
    </div>
  )
}
